// extracted by mini-css-extract-plugin
export default {"container":"SinglePage_container__nEdDy","image":"SinglePage_image__ITY1r","heading":"SinglePage_heading__Eaf5B"};